import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'quote-loading-page',
  templateUrl: './quote-loading-page.component.html',
  styleUrls: ['./quote-loading-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteLoadingPageComponent {}
